import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAuthFeatures } from '../../types/features';

const initialState: IAuthFeatures = {
  authorized: false,
  isWidgetOpen: true,
};

/* istanbul ignore next */
const authSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    setWidgetOpen: (state, action: PayloadAction<boolean>) => {
      state.isWidgetOpen = action.payload;
    },
  },
});

export const { reducer: authReducer } = authSlice;
export const { setWidgetOpen } = authSlice.actions;
